module.exports = __webpack_public_path__ + "static/media/leran-info-icon.ee2f6006.svg";